import {
  REFRESH_GROUP_BALANCES_START,
  REFRESH_GROUP_BALANCES_SUCCESS,
  REFRESH_GROUP_BALANCES_FAILED,
} from 'constants/action-types/groups/refreshGroupBalances';

export default (state, { type, payload }) => {
  switch (type) {
    case REFRESH_GROUP_BALANCES_START:
      return {
        ...state,
        refreshGroupBalances: {
          ...state.refreshGroupBalances,
          loading: true,
          error: null,
          message: null,
        },
      };
    case REFRESH_GROUP_BALANCES_SUCCESS:
      return {
        ...state,
        refreshGroupBalances: {
          ...state.refreshGroupBalances,
          message: payload.message,
          error: null,
          loading: false,
        },
      };
    case REFRESH_GROUP_BALANCES_FAILED:
      return {
        ...state,
        refreshGroupBalances: {
          ...state.refreshGroupBalances,
          loading: false,
          error: payload,
          message: null,
        },
      };
    default:
      return null;
  }
};
